import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";
import { Provider, EMAILPROVIDERS } from '../model/providers.modals';
import { CustomField } from "../model/custom-field.modals";
@Injectable({
  providedIn: "root",
})
export class UtilityService {
  serverURL = environment.serverUrl;
  constructor(private httpClient: HttpClient) {}

  /**
   * To get list of countries
   */
  getCountriesList() {
    return this.httpClient.get(this.serverURL + "utility/countries");
  }
  /**
   * To get list of states for a given country
   * @param countryID
   */
  getStatesList(countryID) {
    return this.httpClient.get(
      this.serverURL + `utility/states/countryId/${countryID}`
    );
  }
   /**
   * To get user name initials
   * @param {string} email
   * @memberof UtilityService
   */
  getUserNameInitials(email:string){
    return email.slice(0,2).toUpperCase()
  }
  saveProviders(model:Provider){
    return this.httpClient.post(this.serverURL +"utility/email/providers",model);
  }
  getProviderDetails(clientId:string,providerId:EMAILPROVIDERS) {
    return this.httpClient.get(
      this.serverURL + `utility/email/providers/${clientId}/${providerId}`
    );
  }
  setDefaultProvider(model:{clientId:string,providerId:EMAILPROVIDERS,isDefault:Boolean}){
    return this.httpClient.post(this.serverURL +"utility/email/providers/default",model);
  }
  toggleCustomProvider(model:{clientId:string, useMyCustomProvider:Boolean}){
    return this.httpClient.post(this.serverURL +"utility/email/providers/custom-provider",model);
  }
  getClientProvider(clientId:string) {
    return this.httpClient.get(
      this.serverURL + `utility/email/providers/${clientId}`
    );
  }
  addOrUpdateMFA(model:{clientId:string,factor:string,apps:any}){
    return this.httpClient.post(this.serverURL +"utility/mfa/new",model);
  }
  enableMFA(model:{clientId:string,allowMfa:string}){
    return this.httpClient.post(this.serverURL +"utility/mfa/allow-mfa",model);
  }
  getMfaList(clientId:any){
    return this.httpClient.get(
      this.serverURL + `utility/mfa/${clientId}`
    );
  }
    removeAppFromMFA(model:{clientId:string,appId:string,factor}){
      return this.httpClient.post(this.serverURL+`utility/mfa/delete`,model)
    }
    removeAllAppFromMFA(model:{clientId:string,apps:any[],factor:string}){
      return this.httpClient.post(this.serverURL+`utility/mfa/delete-all`,model)
    }



  sendTestMail(configDetails:any){
    return this.httpClient.post(this.serverURL +"utility/email/providers/send-test-mail",configDetails);
  }
  saveCustomField(model:CustomField){
    return this.httpClient.post(this.serverURL+`utility/custom-fields`,model);
  }
  updateCustomField(model:CustomField){
    return this.httpClient.put(this.serverURL+`utility/custom-fields/${model._id}`,model);

  }
  fetchCustomField(id:any){
    return this.httpClient.get(this.serverURL+`utility/custom-fields/fields/${id}`);

  }
  fetchCustomFields(orginizationId:any,all:any=undefined){
    return this.httpClient.get(this.serverURL+`utility/custom-fields/${orginizationId}?visible=${all}`);

  }
  deleteCustomField(customFieldId:any){
    return this.httpClient.delete(this.serverURL+`utility/custom-fields/${customFieldId}`);

  }

}
